import { fetchBackend } from '@/utils/fetch'

/**
 * 获取字典
 * @param {string[]} dict_types
 */
export const getDict = (dict_types: string[]) =>
  fetchBackend.post('/pe/gatekeeper/pe/bff/platform/v1/open/dict/tree', {
    params: { dict_types },
  })
